var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.product)?_c('product-selector',{attrs:{"id":_vm.$route.params.id,"full-view":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }